var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-grid"},_vm._l((_vm.docs),function(doc,index){return _c('DocsCard',{key:((doc.title) + "-" + (doc.date)),attrs:{"document":doc,"order":index+1}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }